import axios from "axios";
import env from "../variables/config";

axios.defaults.baseURL = env.apiUrl;

const config = () => ({
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
});

export type ImportEstablishmentsPeopleCsvResponse = {
    processedRows: number;
    totalRows: number;
    skippedRows: number;
    created: {
        establishments: number;
        people: number;
        links: number;
    };
    updated: {
        establishments: number;
        people: number;
    };
    errors: Array<{
        rowNumber: number;
        message: string;
        row: Record<string, unknown>;
        context: {
            establishment: {
                name: string;
                siret: string;
                siren: string;
                website_url: string;
                city: string;
                postcode: string;
            };
            person: {
                name: string;
                linkedinUrl: string;
            };
        };
    }>;
    skipped: Array<{
        rowNumber: number;
        message: string;
        row: Record<string, unknown>;
        context: {
            establishment: {
                name: string;
                siret: string;
                siren: string;
                website_url: string;
                city: string;
                postcode: string;
            };
            person: {
                name: string;
                linkedinUrl: string;
            };
        };
    }>;
};

export async function importEstablishmentsPeopleCsv(
    file: File
): Promise<ImportEstablishmentsPeopleCsvResponse> {
    const formData = new FormData();
    formData.append("file", file);
    const response = await axios.post(
        "/admin/import/establishments-people",
        formData,
        config()
    );
    return response.data;
}
